import React, { useState } from 'react';
const faqs = [{
  q: 'Wie erhalte ich das Material?',
  a: 'Nach dem Kauf erhältst du sofort digitalen Zugriff auf die PDF-Dateien. Du kannst sie herunterladen, speichern und ausdrucken.'
}, {
  q: 'Ist es ein Abo?',
  a: 'Nein. Es ist ein einmaliger Kauf. Du zahlst einmal und erhältst das digitale Paket.'
}, {
  q: 'Kann ich die PDFs ausdrucken?',
  a: 'Ja. Alle Materialien sind als PDF angelegt und können digital genutzt oder ausgedruckt werden.'
}, {
  q: 'Ist das Material für Deutschland geeignet?',
  a: 'Ja. Das Paket wurde für den Sportunterricht in Deutschland entwickelt und orientiert sich an typischen Kompetenzbereichen wie Bewegung, Spiel, Leistung, Gesundheit, Kooperation, Fair Play und Sicherheit.'
}, {
  q: 'Funktioniert es auch mit wenig Material?',
  a: 'Ja. Zusätzlich zu den Hauptbänden erhältst du den Bonus „Sporthalle-Minimalismus“ mit 50 Stundenideen für wenig oder gar kein Material.'
}, {
  q: 'Ist es auch für Vertretungsstunden geeignet?',
  a: 'Ja. Der Bonus „Notfallstunden-Paket für Sportlehrer“ enthält 20 sofort einsetzbare Stunden für Vertretung, Stresssituationen und Planungsnotfälle.'
}, {
  q: 'Kann ich es für verschiedene Klassenstufen nutzen?',
  a: 'Ja. Das Paket enthält 12 Bände von Grundschule bis Sekundarstufe / Oberstufe.'
}, {
  q: 'Was passiert, wenn es mir nicht gefällt?',
  a: 'Du hast 7 Tage Garantie. Wenn du nicht zufrieden bist, bekommst du dein Geld zurück.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-alt py-20 sm:py-24 px-4" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <div className="text-center mb-12" data-id="element-84">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-85">
            Häufige Fragen
          </h2>
        </div>

        <div className="space-y-4" data-id="element-86">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-bg-main border border-border-light rounded-2xl overflow-hidden" data-id="element-87">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-88">
                  <span className="font-bold text-text-main text-lg" data-id="element-89">
                    {faq.q}
                  </span>
                  <span className={`text-2xl text-primary transition-transform ${isOpen ? 'rotate-45' : ''}`} data-id="element-90">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-91">
                  <p className="text-text-sec text-base" data-id="element-92">{faq.a}</p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}